import { RowInfo } from '../models/row-info';
import { SagittaScoreArea } from '../models/sagitta-score-area';
import { aRows } from './a-rows';
import { bRows } from './b-rows';
import { cRows } from './c-rows';
import { dRows } from './d-rows';
import { eRows } from './e-rows';

export const genRowsRecord = () => {
  const rowsRecord: Partial<Record<SagittaScoreArea['area'], RowInfo[][]>> = {
    A: aRows(),
    B: bRows(),
    C: cRows(),
    D: dRows(),
    E: eRows(),
  };
  return rowsRecord;
};
